<template>
    <v-row no-gutters class="pt-2">
        <v-col>
            <v-card>
                <v-skeleton-loader
                        type="table"
                        :boilerplate="!dataLoading"
                        v-if="showSkeleton"
                        max-height="350"
                ></v-skeleton-loader>
                <v-data-table
                        v-else
                        :dense="false"
                        hide-default-footer
                        :headers="_headers"
                        :items="productTableData"
                        item-key="name"
                        @click:row="handleRowClick"
                        :options.sync="options"
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.name" class="custom-row" @click="handleRowClick(item)">
                            <td
                                    v-for="h in productHeaders"
                                    :key="h.value"
                                    class="custom-cell"
                                    :style="getCellStyle(h, item)"
                            >
                                {{
                                    h.value === "product_name" || h.value === "product_code"
                                            ? item[h.value]
                                            : h.value === "rules_percent"
                                                    ? Math.round(item[h.value]) + '%'
                                                    : Math.round(item[h.value])
                                }}
                            </td>
                        </tr>
                        </tbody>
                    </template>

                    <template v-slot:footer="{ props }">
                        <v-row class="pr-8 py-3" align="center" justify="end" style="">
                            <span class="pagination-text mr-2" style="white-space: nowrap">
                                {{ t("Rows per page") }}:
                            </span>

                            <div class="dropdown-div">
                                <dropdown
                                        type="single"
                                        position="top"
                                        :items="rowsPerPageOptions"
                                        :show-search="false"
                                        :value="options.itemsPerPage"
                                        :field-height="36"
                                        @select="updateRowsPerPage"
                                />
                            </div>

                            <span class="mx-6 custom-pagination-location pagination-text">
                                {{ props.pagination.pageStart + 1 }}–{{ props.pagination.pageStop }} of
                                {{ props.pagination.itemsLength }}
                            </span>

                            <v-btn
                                    icon
                                    class="pagination-btn"
                                    @click="options.page--"
                                    :disabled="options.page <= 1"
                                    style="margin-right: 12px"
                                    :ripple="false"
                            >
                                <i class="fal fa-chevron-left"></i>
                            </v-btn>
                            <v-btn
                                    icon
                                    class="pagination-btn"
                                    @click="options.page++"
                                    :disabled="options.page >= props.pagination.pageCount"
                                    :ripple="false"
                            >
                                <i class="fal fa-chevron-right"></i>
                            </v-btn>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Dropdown from "@/components/dropdown/dropdown.vue";

export default {
    name: "analysis-product-table-row",
    components: { Dropdown },
    data() {
        return {
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            rowsPerPageOptions: [
                { text: "5", value: 5 },
                { text: "10", value: 10 },
                { text: "15", value: 15 },
                { text: "50", value: 50 },
                { text: "100", value: 100 },
                { text: "500", value: 500 },
                { text: "1000", value: 1000 },
                { text: "5000", value: 5000 },
            ],
        };
    },
    mounted() {
    },
    methods: {
        ...mapMutations("AnalysisStore", ["updateFilters"]),
        handleRowClick(row) {
            const productCode = row.product_code;
            const productBrandId = row.product_brand_id;
            const productCategoryId = row.product_category_id;
            console.log(productCode)
            if (productCode && !this.filters.productCodes.includes(productCode)) {
                this.filters.productCodes = [...this.filters.productCodes, productCode];
            }
            if (productBrandId && !this.filters.brandIds.includes(productBrandId)) {
                this.filters.brandIds = [...this.filters.brandIds, productBrandId];
            }
            if (productCategoryId && !this.filters.categoryIds.includes(productCategoryId)) {
                this.filters.categoryIds = [...this.filters.categoryIds, productCategoryId];
            }

            this.updateFilters({ value: this.filters.productCodes, filter: "productCodes" });
            this.updateFilters({ value: this.filters.brandIds, filter: "brandIds" });
            this.updateFilters({ value: this.filters.categoryIds, filter: "categoryIds" });

            this.options.page = 1;
        },
        updateRowsPerPage(selectedValue) {
            this.options.itemsPerPage = selectedValue;
        },
        getCellStyle(h, item) {
            const boldKeys = ["product_name", "turnover_cy1cy2_diff"];
            let fontWeight = boldKeys.includes(h.value) ? "bold" : "normal";

            let color = "rgba(100, 100, 100, 1)";
            if (h.value === "product_name") {
                color = "black";
            } else if (h.value === "turnover_cy1cy2_diff") {
                const val = item[h.value];
                color = val > 0 ? "green" : val < 0 ? "red" : "inherit";
            }

            return { fontWeight, color };
        },
    },
    computed: {
        ...mapState("AnalysisStore", ["productHeaders", "dataLoading", "showSkeleton", "filters", "productTableData"]),
        _headers() {
            return this.productHeaders.map(h => ({...h, text: this.t(h.text)}))
        }
    },
};
</script>
<style scoped>
.custom-row {
    min-height: 40px;
    height: 40px;
}

.custom-cell {
    padding: 9px 20px;
    vertical-align: middle;
    font-size: 13px !important;
}

.header-text {
    color: rgba(141, 153, 146, 1) !important;
}

.cell-text {
    color: rgba(100, 100, 100, 1) !important;
}

.pagination-btn-wrapper {
    display: flex;
    gap: 12px;
}

.pagination-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    gap: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn i {
    font-size: 20px;
}

.pagination-text {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    vertical-align: middle;
    color: rgba(141, 153, 146, 1);
}

.dropdown-div {
    width: 80px;
    height: 100%;
    display: flex;
    align-items: center;
}
</style>
